import React from "react";
import CountDown from "../Components/CountDown";
import CountDownOverlay from "../Components/CountDonwOverlay";
import Wrapper from "../Components/Wrapper";
import { basePath } from "../Components/Helpers";


const MemoryCountDown = () => {

    return (
        <CountDownOverlay background={"linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/memory-countdown-background.png)"} />
    );
};

export default MemoryCountDown;